import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const LoginRoute: React.FC = () => {
  const { entityName } = useParams<{ entityName: string }>();
  const isAuthenticated = useSelector((state: RootState) => state.user.userAuth);
  const user = useSelector((state: RootState) => state.user.user);

  return isAuthenticated ? user.user_type === "external_municipal" ? <Navigate to={`/${entityName}/cities`} /> : <Navigate to={`/${entityName}/city`} /> : <Outlet />;
};

export default LoginRoute;